module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<small><time datetime="'+
((__t=( timestamp ))==null?'':__t)+
'">'+
((__t=( date ))==null?'':__t)+
'</time></small><div class="log-entry-wrap"><pre>'+
((__t=( content ))==null?'':__t)+
'</pre><a href="#" class="details-button icon icon-material icon-expand" data-toggle="expand-spoiler"><span class="screen-reader-text">'+
((__t=( i18n.tc( "LogEntry", "Show meta information" ) ))==null?'':__t)+
'</span></a><div class="expand-spoiler" data-container="expand-spoiler"><div class="expand-content"><dl><dt>'+
((__t=( i18n.tc( "LogEntry", "Logged by:" ) ))==null?'':__t)+
' <dd>'+
((__t=( transientChangee ))==null?'':__t)+
' <dt>'+
((__t=( i18n.tc( "LogEntry", "Tagged under:" ) ))==null?'':__t)+
' <dd>'+
((__t=( translatedTags ))==null?'':__t)+
' <dt>'+
((__t=( i18n.tc( "LogEntry", "Tagged on:" ) ))==null?'':__t)+
' <dd>'+
((__t=( taggedOn ))==null?'':__t)+
' </dd></dt></dd></dt></dd></dt></dl></div></div></div>';
}
return __p;
};
